import '@ant-design/compatible/assets/index.css';
import React from 'react';

import { DatePicker, Row } from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import TextArea from 'antd/lib/input/TextArea';
import UtinaCard from 'components/UtinaCard';

const TabAwaitDocumentReminder = (props: any) => {

  return (
    <DF.Provider pagcode="tabawaitdocumentreminder">
        <UtinaCard comcode="Appointement" level={5}>
        <Row gutter={[8, 8]}>
          <FormInput
            col
            xs={6}
            name="taskdate"
            comcode="taskdate"
            rules={[{ required: true }]}
          >
            <DatePicker />
          </FormInput>

          <FormInput
            col
            xs={20}
            name="comment"
            rules={[{ required: true }]}
          >
            <TextArea rows={4} />
          </FormInput>
        </Row>
        </UtinaCard>
    </DF.Provider>
  );
};
export default TabAwaitDocumentReminder;
